import React from 'react';
import { VertTypography } from '@vertem-core/vertice-ds';
import {
  handleTrackingTextDotStatusCode,
} from '../Utils/SpotUtils';

const OrderStatusTracking = ({
  trackingStatusCode,
  dotStatus,
  trackingText,
}) => {
  return (
    <VertTypography.Paragraph
      className={`order-status-tracking approved`}
    >
      {handleTrackingTextDotStatusCode(
        trackingStatusCode,
        dotStatus,
        trackingText
      )}
    </VertTypography.Paragraph>
  );
};

export default OrderStatusTracking;
